
import { useState } from "react";

interface AccordionProps {
  title: string;
  children: React.ReactNode;
  isOpen?: boolean;
}

export default function Accordion({ title, children, isOpen = false }: AccordionProps) {
  const [open, setOpen] = useState(isOpen);

  const toggleOpen = () => {
    setOpen(!open);
  }

  return (
    <div style={{ 
      borderRadius: '8px', 
      border: '1px solid #e4e4e7', 
      marginBottom: '16px' 
    }}>
      <button
        onClick={toggleOpen}
        style={{ 
          width: '100%', 
          padding: '16px 24px', 
          textAlign: 'left', 
          display: 'flex', 
          justifyContent: 'space-between', 
          alignItems: 'center', 
          border: 'none',
          cursor: 'pointer',
          transition: 'background-color 0.2s'
        }}
        onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#cccccc'}
        onMouseLeave={(e) => e.currentTarget.style.backgroundColor = '#fafafa'}
      >
        <h3 style={{ fontSize: '1.125rem', fontWeight: '600'}}>
          {title}
        </h3>
        <span style={{ fontSize: '1.5rem' }}>
          {open ? '−' : '+'}
        </span>
      </button>
      {open && (
        <div style={{ padding: '0 24px 16px 24px' }}>
          <div style={{ lineHeight: '1.6' }}>
            {children}
          </div>
        </div>
      )}
    </div>
  );
}